module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMTQuNDE3IiBoZWlnaHQ9IjM1OC42NzgiIHZpZXdCb3g9IjAgMCAzMTQuNDE3IDM1OC42NzgiPgogIDxwYXRoIGlkPSLjg5HjgrlfMzU5NyIgZGF0YS1uYW1lPSLjg5HjgrkgMzU5NyIgZD0iTTUxNy4yMzIsMTIyOC4yMTZWOTg4LjdMODMxLjY0OSw4NjkuNTM2djIzOS41MTFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTE3LjIzMSAtODY5LjUzNykiIGZpbGw9ImxpbWUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/green_314.svg
// module id = Xhwt
// module chunks = 0